import type {ComponentType} from 'react';

import type {Product} from 'shells/billing/types';
import {ChartLineRegularReportIcon} from 'shells/icon/svg/chart-line-regular-report-icon';
import {CircleDollarRegularIcon} from 'shells/icon/svg/circle-dollar-regular-icon';
import {CloudUploadRegularIcon} from 'shells/icon/svg/cloud-upload-regular-icon';
// @ts-expect-error
import {PencilToPaperIcon} from 'shells/icon/svg/pencil-to-paper-icon';
import {StarRegularIcon} from 'shells/icon/svg/star-regular-icon';
import {SyncRegularIcon} from 'shells/icon/svg/sync-regular-icon';

type AddOnConfig = {
    title: string;
    description: string;
    illustrationSrc: string;
    useModal?: boolean;
    hrefKey?: Product;
};

export const ADD_ONS_CONFIG: AddOnConfig[] = [
    {
        title: 'Email marketing',
        description:
            'Create emails with our intuitive builder. Segment audiences and track engagement.',
        illustrationSrc: 'trial-add-ons/email-marketing',
        useModal: true,
    },
    {
        title: 'SMS',
        description: 'Communicate with leads and customers via text messages.',
        illustrationSrc: 'trial-add-ons/sms',
        hrefKey: 'SMS_CAMPAIGNS',
    },
    {
        title: 'Nutshell IQ',
        description:
            'Find new prospects, gather company info, and turn cold websites into warm leads.',
        illustrationSrc: 'trial-add-ons/nutshell-iq',
        hrefKey: 'NUTSHELL_IQ',
    },
    {
        title: 'Quotes & Invoices',
        description: 'Create and send unlimited quotes and invoices with shareable links.',
        illustrationSrc: 'trial-add-ons/quote',
        hrefKey: 'QUOTES',
    },
    {
        title: 'Nutshell Advisor',
        description:
            'Get personalized advice from a Nutshell Advisor to help you grow your business.',
        illustrationSrc: 'trial-add-ons/advisor',
        hrefKey: 'NUTSHELL_ADVISOR',
    },
];

export const FEATURE_BULLETS: {icon: ComponentType<any>; title: string}[] = [
    {
        icon: CircleDollarRegularIcon,
        title: 'Powerful sales automation',
    },
    {
        icon: SyncRegularIcon,
        title: 'Email and calendar sync',
    },
    {
        icon: PencilToPaperIcon,
        title: 'Native forms for lead generation',
    },
    {
        icon: ChartLineRegularReportIcon,
        title: 'Sales and marketing reporting',
    },
    {
        icon: CloudUploadRegularIcon,
        title: 'One-click data import',
    },
    {
        icon: StarRegularIcon,
        title: 'And a lot more...',
    },
];
